import { Spin } from "antd";
import { OverviewGroupSummary } from "Services/Api/Dashboard/Types";
import { renderScoreCell, renderTagCell } from "./columns";
import styles from './GroupSummaryTable.module.scss';

const TableDataCard = ({ data, loading }: { data: OverviewGroupSummary, loading: boolean }) => {
    return <Spin spinning={loading} wrapperClassName={styles.loadingCard}>
        <div className={styles.cardMobileView}>
            <div className={styles.heading}>{data?.groupName || ''}</div>
            <div>
                <div className={styles.row}>
                    <div className={styles.label}>Phishing</div>
                    {renderScoreCell(data?.phishingScore ?? 0)}
                </div>
                <div className={styles.row}>
                    <div className={styles.label}>Training</div>
                    {renderScoreCell(data?.elearningScore ?? 0)}
                </div>
                <div className={styles.row}>
                    <div className={styles.label}>SAQ Compliance</div>
                    {renderTagCell(data?.saqStatus ?? "")}
                </div>
                <div className={styles.row}>
                    <div className={styles.label}>Scanning</div>
                    {renderTagCell(data?.scanningStatus ?? "")}
                </div>
            </div>
        </div>
    </Spin>
}

export default TableDataCard;